<!-- =========================================================================================
    File Name: Login.vue
    Description: Login Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div class="h-screen flex w-full bg-img vx-row no-gutter items-center justify-center" id="page-login">
    <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-3/5 sm:m-0 m-4">
      <vx-card>
        <div slot="no-body" class="full-page-bg-color">

          <div class="vx-row no-gutter justify-center items-center">

            <div class="vx-col hidden lg:block lg:w-1/2">
              <img src="@/assets/images/logo/LogoFull.png" width="350" alt="login" class="mx-auto my-auto">
            </div>

            <div class="vx-col sm:w-full md:w-full lg:w-1/2 d-theme-dark-bg">
              <div class="p-8 login-tabs-container">

                <div class="vx-card__title mb-4">
                  <h4 class="mb-4">Acceso</h4>
                  <p>Por favor seleccione el método de acceso</p>
                </div>

                <div>

                  <div class="social-login-buttons flex flex-row items-center mt-4">

                    <!-- GOOGLE -->
                    <div class="flex flex-row items-center bg-google rounded-lg cursor-pointer mr-8 h-16" @click="loginWithGoogle">
                      <img class="m-2 h-12" src="@/assets/images/logo/GoogleIcon.png" alt="Acceso por Google">
                      <div class="h-full w-px bg-white"></div>
                      <div class="flex text-white items-center text-md m-4 border-l-2 border-white">Acceder con Google</div>
                    </div>

                    <!-- facebook -->
                    <div class="flex flex-row items-center bg-facebook rounded-lg cursor-pointer h-16" @click="loginWithFacebook">
                      <img class="m-2 h-12" src="@/assets/images/logo/facebookIcon.png" alt="Acceso por Facebook">
                      <div class="h-full w-px bg-white"></div>
                      <div class="flex text-white items-center text-md m-4 border-l-2 border-white">Acceder con facebook</div>
                    </div>

                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>

<script>
  export default{
    data() {
      return {
        email: "",
        password: "",
        validationCode: '',
        checkbox_remember_me: false,
        codeSent: false
      }
    },
    methods: {
      checkLogin () {
        // If user is already logged in notify
        if (this.$store.state.auth.isUserLoggedIn()) {

          // Close animation if passed as payload
          // this.$vs.loading.close()

          this.$vs.notify({
            title: 'Intento de acceso',
            text: 'Usted ya accedió a la tienda',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'warning'
          })

          return false
        }
        return true
      },

      // Google login
      loginWithGoogle () {
        this.$store.dispatch('auth/loginWithGoogle', { notify: this.$vs.notify })
      },

      // Facebook login
      loginWithFacebook () {
        if (this.checkLogin) {
          this.$store.dispatch('auth/loginWithFacebook', {self: this, notify: this.$vs.notify})
        }
      },

      login () {
        if (!this.checkLogin()) return;
        this.validationCode = '';
        // this.$auth.login({ target: this.$route.query.to })
        this.$auth.passwordlessStart(this.email);
        this.codeSent = true;
      },
      validate () {
        this.$auth.passwordlessLogin(this.email, this.validationCode);
      },
      registerUser () {
        if (!this.checkLogin()) return
        this.$router.push('/pages/register').catch(() => {})
      }
    }
  }
</script>

<style lang="scss">
  #page-login {
    .social-login-buttons {
      .bg-facebook { background-color: #3B5998 }
      .bg-twitter { background-color: #00aaff }
      .bg-google { background-color: #DD4B39 }
      .bg-github { background-color: #333 }
    }
  }
</style>
